<style>
	:global(.smui-select--standard.mdc-select--with-leading-icon .mdc-select__anchor) {
		padding-left: 0px;
	}
	:global(.smui-select--standard.mdc-select--with-leading-icon .mdc-floating-label) {
		left: 0px;
	}
</style>

<script>
	import { locales } from '../../services/l10n.js';
	import { createEventDispatcher } from 'svelte';
	import Select, { Option } from '@smui/select';

	export let value;
	const dispatch = createEventDispatcher();
	function handleLocaleChange(value) {
		dispatch('locale-changed', value);
	}
</script>

<Select label="Locale:" bind:value="{value}">
	<svelte:fragment slot="leadingIcon">
		<div class="h-3">
			<img href="/" src="./assets/images/{value}.png" alt="" class="pr-2" />
		</div>
	</svelte:fragment>
	{#each Object.keys(locales) as locale}
		<Option
			value="{locale}"
			on:click="{() => {
				value = locale;
				handleLocaleChange(value);
			}}"><img href="/" src="./assets/images/{locale}.png" alt="" class="pr-2" /><span>{locales[locale]}</span></Option
		>
	{/each}
</Select>
